import { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./Header.css";

const NAV_LINKS = [
  { id: "banner", label: "Home", to: "/home#banner" },
  { id: "about", label: "About", to: "/home#about" },
  { id: "skills", label: "Skills", to: "/home#skills" },
  { id: "projects", label: "Projects", to: "/home#projects" },
  { id: "contact", label: "Contact", to: "/home#contact" },
];

const Header = ({ loading }) => {
  const [activeSection, setActiveSection] = useState("banner");
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (loading) return; // Wait until the loader is gone

    const sections = document.querySelectorAll("section[id]");
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        root: null,
        rootMargin: "-40% 0px -55% 0px",
        threshold: 0,
      },
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [loading, location.pathname]); // Re-run when `loading` changes

  const closeMenu = () => setExpanded(false);

  return (
    <header className="site-header">
      <Navbar
        collapseOnSelect
        expand="lg"
        variant="dark"
        fixed="top"
        expanded={expanded}
        onToggle={setExpanded}
        className={`site-navbar ${scrolled || expanded ? "is-scrolled" : ""}`}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="brand-link" onClick={closeMenu}>
            <span className="brand">
              Shoieb<span className="brand-dot">.</span>
            </span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" aria-label="Toggle navigation" className="nav-toggle" />

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto align-items-lg-center site-nav fw-bold">
              {NAV_LINKS.map((link) => (
                <Nav.Link
                  key={link.id}
                  as={HashLink}
                  smooth
                  to={link.to}
                  onClick={closeMenu}
                  className={`site-nav-link ${activeSection === link.id ? "active" : ""}`}
                >
                  {link.label}
                </Nav.Link>
              ))}

              <a
                href="https://drive.google.com/file/d/1s7dAJ0P7SgWr7vinJ_qyCUsIaHyKNv7s/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="resume-btn"
                onClick={closeMenu}
              >
                <FaDownload size={15} aria-hidden="true" />
                <span>Resume</span>
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
